var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPaperPlaneSolid = function SvgPaperPlaneSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5928 2.12617L2.49096 12.5694C1.78408 12.9756 1.8739 13.9597 2.57688 14.2566L6.72839 15.9984L17.9488 6.10975C18.1636 5.91838 18.4682 6.21129 18.2847 6.4339L8.8764 17.8964V21.0403C8.8764 21.962 9.98946 22.3252 10.5362 21.6574L13.0162 18.6385L17.8824 20.6771C18.437 20.9115 19.0697 20.5639 19.1712 19.9663L21.9831 3.09473C22.1159 2.30583 21.2684 1.73563 20.5928 2.12617Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaperPlaneSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paper_plane_solid.179767f6.svg";
export { ForwardRef as ReactComponent };